/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CallDealerModal_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $refType": "CallDealerModal_item";
};
export type CallDealerModal_item$data = CallDealerModal_item;
export type CallDealerModal_item$key = {
    readonly " $data"?: CallDealerModal_item$data;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "CallDealerModal_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '8a0622c8f30902723b719505e0e1dab5';
export default node;
